export default __webpack_public_path__ + "static/media/Group9170.a327c39f.svg";